(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["legend-explorer"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('legend-explorer')) {
    class LegendExplorer extends HTMLElement {
      connectedCallback() {
        this.tabs = Array.from(this.querySelectorAll('[role="tab"]'));
        if (this.tabs.length === 0) return;

        this.panels = Array.from(this.querySelectorAll('[data-panel]'));
        this.images = Array.from(this.querySelectorAll('[data-image]'));
        this.counter = this.querySelector('[data-counter]');
        this.sheen = this.querySelector('.legend-explorer__sheen');
        this.index = 0;
        this.hovering = false;
        this.visible = false;

        const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        this.autoplay = this.dataset.autoplay === 'true' && !reduced && this.tabs.length > 1;

        this.tabs.forEach((tab, i) => {
          tab.addEventListener('click', () => {
            this.stopAutoplay();
            this.select(i);
          });
          tab.addEventListener('keydown', (event) => this.onKeydown(event, i));
        });

        this.addEventListener('animationend', (event) => {
          if (event.animationName === 'legend-progress') {
            this.select((this.index + 1) % this.tabs.length);
          }
        });

        this.addEventListener('pointerenter', () => {
          this.hovering = true;
          this.updatePlayState();
        });
        this.addEventListener('pointerleave', () => {
          this.hovering = false;
          this.updatePlayState();
        });
        this.addEventListener('focusin', () => {
          this.hovering = true;
          this.updatePlayState();
        });
        this.addEventListener('focusout', (event) => {
          if (!this.contains(event.relatedTarget)) {
            this.hovering = false;
            this.updatePlayState();
          }
        });

        this.observer = new IntersectionObserver(
          (entries) => {
            this.visible = entries[0].isIntersecting;
            this.updatePlayState();
          },
          { threshold: 0.35 }
        );
        this.observer.observe(this);

        if (this.autoplay) this.classList.add('is-playing');
        this.updatePlayState();
      }

      disconnectedCallback() {
        if (this.observer) this.observer.disconnect();
      }

      updatePlayState() {
        const paused = !this.autoplay || this.hovering || !this.visible;
        this.classList.toggle('is-paused', paused);
      }

      stopAutoplay() {
        this.autoplay = false;
        this.classList.remove('is-playing');
        this.updatePlayState();
      }

      onKeydown(event, i) {
        const keys = { ArrowRight: 1, ArrowDown: 1, ArrowLeft: -1, ArrowUp: -1 };
        if (!(event.key in keys)) return;
        event.preventDefault();
        const next = (i + keys[event.key] + this.tabs.length) % this.tabs.length;
        this.stopAutoplay();
        this.select(next);
        this.tabs[next].focus();
      }

      restartAnimation(element, className) {
        if (!element) return;
        element.classList.remove(className);
        void element.offsetWidth;
        element.classList.add(className);
      }

      select(i) {
        if (i === this.index && this.tabs[i].classList.contains('is-active')) return;
        this.index = i;

        this.tabs.forEach((tab, n) => {
          const active = n === i;
          tab.classList.toggle('is-active', active);
          tab.setAttribute('aria-selected', active ? 'true' : 'false');
          tab.tabIndex = active ? 0 : -1;
        });

        this.panels.forEach((panel, n) => {
          const active = n === i;
          panel.classList.toggle('is-active', active);
          const cta = panel.querySelector('a');
          if (cta) cta.tabIndex = active ? 0 : -1;
        });

        this.images.forEach((image, n) => {
          if (n === i) {
            this.restartAnimation(image, 'is-active');
          } else {
            image.classList.remove('is-active');
          }
        });

        this.restartAnimation(this.sheen, 'is-sweeping');

        if (this.counter) this.counter.textContent = String(i + 1).padStart(2, '0');

        const activeTab = this.tabs[i];
        const list = activeTab.parentElement;
        if (list && list.scrollWidth > list.clientWidth) {
          list.scrollTo({ left: activeTab.offsetLeft - list.offsetLeft, behavior: 'smooth' });
        }
      }
    }

    customElements.define('legend-explorer', LegendExplorer);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
